<!--suppress XmlInvalidId -->
<p-card styleClass="facility-card">
    <ng-template pTemplate="body">
        <div class="p-d-flex p-jc-end">
            <button pButton [icon]="icons.TIMES" (click)="stopEditing()"
                    class="p-button-secondary"></button>
        </div>
        <form *ngIf="formMap; let formMap" ngForm>
            <div class="p-fluid name-input p-mb-6">
                <label for="facilityName">Facility Name</label>
                <input id="facilityName" pInputText [formControl]="formMap.facilityName">
            </div>

            <div class="p-mb-6">
                <h4>Company Logo</h4>
                <div class="p-grid p-flex-column p-ai-center p-jc-center">
                    <div class="p-col-12 p-d-flex p-jc-center" *ngIf="formMap.logoImage.value">
                        <img class="logo-image" [src]="formMap.logoImage.value">
                    </div>
                    <div class="p-col-12 p-grid p-jc-center">
                        <button pButton
                                label="{{formMap.logoImage.value ? 'Replace' : 'Add'}} Logo"
                                [icon]="icons.FILE_IMPORT"
                                (click)="fileUpload.click()">
                        </button>
                        <ng-container *ngIf="formMap.logoImage.value">
                            <button pButton
                                    class="p-button-danger p-ml-2"
                                    label="Remove Logo"
                                    [icon]="icons.TRASH"
                                    (click)="removeLogo()">
                            </button>
                        </ng-container>
                        <input #fileUpload accept=".png, .jpg, .jpeg" (change)="onFileUpload($event)" class="p-d-none" type="file">
                    </div>
                </div>

            </div>

            <h4>Visitor Options</h4>
            <div class="p-fluid input-container">
                <p-divider></p-divider>
                <div class="p-field p-grid">
                    <div class="p-col-6">
                        <label for="selfRegistration">
                            Visitor can self-register
                        </label>
                    </div>
                    <div class="p-col-4">
                        <p-inputSwitch inputId="selfRegistration" [formControl]="formMap.permitSelfRegistration"></p-inputSwitch>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <div class="p-col-6">
                        <label for="selfCheckin">
                            Registered visitors are automatically checked in
                        </label>
                    </div>
                    <div class="p-col-4">
                        <p-inputSwitch inputId="selfCheckin" [formControl]="formMap.permitSelfCheckin"></p-inputSwitch>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <div class="p-col-6">
                        <label for="selfCheckout">
                            Visitors self-checkout
                        </label>
                    </div>
                    <div class="p-col-4">
                        <p-inputSwitch inputId="selfCheckout" [formControl]="formMap.permitSelfCheckout"></p-inputSwitch>
                    </div>
                </div>


            </div>
            <div class="p-fluid p-my-6">
                <h4>Checkout Options</h4>
                <p-divider></p-divider>
                <div class="p-field">
                    <label for="autoCheckout">
                        Automatically Checkout Visitors
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="autoCheckout"
                            selectId="autoCheckout"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.autoCheckout"
                            [options]="$any(checkoutOptions)">
                    </p-dropdown>
                </div>
                <ng-container [ngSwitch]="formMap.autoCheckout.value">
                    <div *ngSwitchCase="'timed'" class="p-fluid">
                        <div class="p-field">
                            <label for="checkoutHrs">
                                Hours until automatic checkout
                            </label>
                            <p-inputNumber inputId="checkoutHrs" [min]="1" [formControl]="formMap.checkoutHrs"></p-inputNumber>
                        </div>
                    </div>
                    <div *ngSwitchCase="'fixed'" class="p-fluid">
                        <div class="p-field">
                            <label for="checkoutTime">
                                Automatically checkout at time
                            </label>
                            <p-calendar inputId="checkoutTime"
                                        appendTo="body"
                                        [timeOnly]="true"
                                        [formControl]="formMap.checkoutTime"
                                        hourFormat="24">
                            </p-calendar>
                        </div>
                    </div>
                </ng-container>
            </div>
            <h4>Fields</h4>
            <p-divider></p-divider>
            <div class="p-grid">
                <div class="p-fluid p-col-6">
                    <label for="firstName">
                        First Name
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="firstName"
                            selectId="firstName"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.dataEntry.firstName"
                            [options]="$any(requiredOptional)">
                    </p-dropdown>
                </div>
                <div class="p-fluid p-col-6">
                    <label for="lastName">
                        Last Name
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="lastName"
                            selectId="lastName"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.dataEntry.lastName"
                            [options]="$any(requiredOptional)">
                    </p-dropdown>
                </div>
                <div class="p-fluid p-col-12">
                    <label for="company">
                        Company
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="company"
                            selectId="company"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.dataEntry.company"
                            [options]="$any(requiredOptional)">
                    </p-dropdown>
                </div>
                <div class="p-fluid p-col-12">
                    <label for="visiting">
                        Visiting
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="visiting"
                            selectId="visiting"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.dataEntry.visiting"
                            [options]="$any(requiredOptionalDisabled)">
                    </p-dropdown>
                </div>
                <div class="p-fluid p-col-12">
                    <label for="phone">
                        Phone Number
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="phone"
                            selectId="phone"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.dataEntry.telephone"
                            [options]="$any(requiredOptionalDisabled)">
                    </p-dropdown>
                </div>
                <div class="p-fluid p-col-12">
                    <label for="citizen">
                        U.S. Citizen
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="citizen"
                            selectId="citizen"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.dataEntry.isCitizen"
                            [options]="$any(requiredDisabled)">
                    </p-dropdown>
                </div>
                <div class="p-fluid p-col-12">
                    <label for="nda">
                       Signed NDA
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="nda"
                            selectId="nda"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.dataEntry.nda"
                            [options]="$any(requiredDisabled)">
                    </p-dropdown>
                </div>
                <div class="p-fluid p-col-12">
                    <label for="photos">
                        Visitor Photos
                    </label>
                    <p-dropdown
                            appendTo="body"
                            inputId="photos"
                            selectId="photos"
                            optionLabel="display"
                            optionValue="value"
                            [formControl]="formMap.visitorPhotos"
                            [options]="$any(visitorPhotoOptions)">
                    </p-dropdown>
                </div>
            </div>

            <div class="p-mt-6 p-d-flex p-jc-between p-ai-center">
                <h4>Escort Access Codes</h4>
                <button pButton class="p-button-success p-button-sm" label="Add Access Code" (click)="addAccessCode()" [icon]="icons.PLUS"></button>
            </div>
            <p-divider></p-divider>
            <div *ngIf="!formMap.accessCodes.length" class="p-d-flex p-jc-center">
                <span>No access codes</span>
            </div>
            <div *ngFor="let access of formMap.accessCodes" class="p-grid">
                <div class="p-col p-fluid">
                    <label>Label</label>
                    <input pInputText [formControl]="access.label">
                </div>
                <div class="p-col p-fluid">
                    <label>Code</label>
                    <input pInputText [formControl]="access.code">
                </div>
                <div class="p-col-1 p-d-flex p-jc-center p-ai-end">
                    <div>
                        <button pButton class="p-button-danger" (click)="removeAccessCode(access)" [icon]="icons.TRASH"></button>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-divider></p-divider>
        <div class="p-d-flex p-jc-end">
            <button pButton label="Cancel" (click)="stopEditing()" class="p-button-secondary p-mr-2"></button>
            <button pButton label="Save" (click)="!validateAndUpdateError().length && save()"></button>
        </div>
        <div *ngIf="errorMessage" class="p-d-flex p-jc-end">
            <p-message severity="error" [text]="errorMessage"></p-message>
        </div>
    </ng-template>
</p-card>

<p-confirmDialog>
</p-confirmDialog>